import React from 'react';
import StyledDivider from './styled';

interface IDivider {
  text?: string;
  size?: 'sm' | 'lg' | 'md';
  sizePx?: number;
}

function Divider(props: IDivider): JSX.Element {
  const { text, size = 'md', sizePx } = props;
  let sizeInPx: number;
  switch (size) {
    case 'sm':
      sizeInPx = 20;
      break;
    case 'lg':
      sizeInPx = 100;
      break;
    default:
      sizeInPx = 30;
  }

  return (
    <StyledDivider size={sizePx || sizeInPx}>
      {text && <span>{text}</span>}
    </StyledDivider>
  );
}

Divider.defaultProps = {
  text: '',
  size: '',
  sizePx: undefined
};

export default Divider;
